import React, { useState, useContext } from "react";
import { Link } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faWallet } from "@fortawesome/free-solid-svg-icons";

import MainHeader from "./MainHeader";
import NavLinks from "./NavLinks";
import SideDrawer from "./SideDrawer";
import Backdrop from "../UIElements/Backdrop";
import { AppConfigContext } from "../../context/appconfig-context";
import "./MainNavigation.css";

const MainNavigation = props => {
    const [drawerIsOpen, setDrawerIsOpen] = useState(false);
    const appConfig = useContext(AppConfigContext);

    const onLanguageSelectHandler = sender => {
        appConfig.changeLanguage(sender.currentTarget.innerHTML);
    };

    const openDrawerHandler = () => {
        setDrawerIsOpen(true);
    };

    const closeDrawerHandler = () => {
        setDrawerIsOpen(false);
    };

    return (
        <>
            {drawerIsOpen && <Backdrop onClick={closeDrawerHandler} />}

            <SideDrawer show={drawerIsOpen} onClick={closeDrawerHandler}>
                <nav className="main-navigation__drawer-nav">
                    <NavLinks />
                </nav>
            </SideDrawer>

            <MainHeader>
                <button
                    className="main-navigation__menu-btn"
                    onClick={openDrawerHandler}>
                    <span />
                    <span />
                    <span />
                </button>
                <h1 className="main-navigation__title">
                    <Link to="/">
                        <FontAwesomeIcon icon={faWallet} />
                        &nbsp;EM
                    </Link>
                </h1>
                <nav className="main-navigation__header-nav">
                    <NavLinks />
                </nav>

                <ul className="main-navigation__language">
                    <li>
                        <button
                            onClick={onLanguageSelectHandler}
                            className={
                                appConfig.language === "English" ? "active" : ""
                            }>
                            English
                        </button>
                        <button
                            onClick={onLanguageSelectHandler}
                            className={
                                appConfig.language === "Portugues"
                                    ? "active"
                                    : ""
                            }>
                            Portugues
                        </button>
                    </li>
                </ul>
            </MainHeader>
        </>
    );
};

export default MainNavigation;
